import React, { FunctionComponent, useState } from 'react'
import FeatherIcon from '@ovaeasy/react-native-vector-icons/Feather'
import * as S from './styled'
import { useRatingTemplate } from '../../hooks/useRatingTemplate'
import theme from '@app/ui/theme'
import { TrashIconContainer } from '../../SelectHoles'

const RatingHoles: FunctionComponent = () => {
  const {
    ratingHoles,
    holeIndexHandler: [holeIndex, setHoleIndex],
    removeRatingHole,
  } = useRatingTemplate()

  const [viewMode] = useState<'grid' | 'compact' | 'table'>('table')

  return (
    <>
{viewMode === 'grid' && (
        <S.RatingHolesContainer>
          {ratingHoles.map((hole, index) => {
            const isSelected = index === holeIndex
            const isFilled =
              hole.courseName !== undefined && hole.courseHoleNumber !== undefined
            return (
              <S.RatingHole
                key={hole.ratingHoleNumber}
                onClick={() => setHoleIndex(index)}
                selected={isSelected}
                style={{ opacity: isFilled ? 1 : 0.7 }}
              >
                <S.Header>
                  <S.Title>Hole: {hole.ratingHoleNumber}</S.Title>
                  {isFilled && (
                    <S.CheckContainer>
                      <FeatherIcon name="check" size={20} color="white" />
                    </S.CheckContainer>
                  )}
                </S.Header>
                <hr
                  style={{
                    padding: 0,
                    margin: 0,
                    borderColor: theme.colors.color13,
                    opacity: 0.3,
                  }}
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: 16,
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <S.HoleInfoText>Course: {hole.courseName}</S.HoleInfoText>
                    <S.HoleInfoText>Hole: {hole.courseHoleNumber}</S.HoleInfoText>
                    <S.HoleInfoText>Par: {hole.par}</S.HoleInfoText>
                  </div>
                  <TrashIconContainer
                    disabled={!isFilled}
                    onClick={(e) => {
                      e.stopPropagation()
                      if (isFilled) {
                        removeRatingHole(index)
                      }
                    }}
                  >
                    <FeatherIcon name="trash" size={20} color="white" />
                  </TrashIconContainer>
                </div>
              </S.RatingHole>
            )
          })}
        </S.RatingHolesContainer>
      )}

      {viewMode === 'compact' && (
        <S.CompactRatingHolesContainer>
          {ratingHoles.map((hole, index) => {
            const isSelected = index === holeIndex
            const isFilled =
              hole.courseName !== undefined && hole.courseHoleNumber !== undefined
            return (
              <S.CompactRatingHoleItem
                key={hole.ratingHoleNumber}
                selected={isSelected}
                filled={isFilled}
                onClick={() => setHoleIndex(index)}
              >
                <S.CompactHoleNumber filled={isFilled}>
                  {hole.ratingHoleNumber}
                </S.CompactHoleNumber>
                <S.CompactHolePar>
                  Par: <S.CompactHoleParValue>{isFilled ? hole.par : '—'}</S.CompactHoleParValue>
                </S.CompactHolePar>
                <S.CompactHoleMeta>
                  Course: <S.CompactHoleMetaValue>{hole.courseName ?? '—'}</S.CompactHoleMetaValue>
                </S.CompactHoleMeta>
                <S.CompactHoleMeta>
                  Hole: <S.CompactHoleMetaValue>{hole.courseHoleNumber ?? '—'}</S.CompactHoleMetaValue>
                </S.CompactHoleMeta>
              </S.CompactRatingHoleItem>
            )
          })}
        </S.CompactRatingHolesContainer>
      )}

      {viewMode === 'table' && (
        <S.TableContainer>
          <S.StyledTable>
            <S.TableHead>
              <tr>
                <S.TableHeaderCell>#</S.TableHeaderCell>
                <S.TableHeaderCell>Par</S.TableHeaderCell>
                <S.TableHeaderCell>Course</S.TableHeaderCell>
                <S.TableHeaderCell>Source Hole</S.TableHeaderCell>
                <S.TableHeaderCell style={{ textAlign: 'right' }}></S.TableHeaderCell>
              </tr>
            </S.TableHead>
            <tbody>
              {ratingHoles.map((hole, index) => {
                const isSelected = index === holeIndex
                const isFilled =
                  hole.courseName !== undefined && hole.courseHoleNumber !== undefined
                return (
                  <S.TableRow
                    key={hole.ratingHoleNumber}
                    selected={isSelected}
                    filled={isFilled}
                    separatorAfter={hole.ratingHoleNumber === 9 && ratingHoles.length > 9}
                    onClick={() => setHoleIndex(index)}
                  >
                    <S.TableCell filled={isFilled}>{hole.ratingHoleNumber}</S.TableCell>
                    <S.TableCell filled={isFilled}>{isFilled ? hole.par : '—'}</S.TableCell>
                    <S.TableCell filled={isFilled}>{hole.courseName ?? '—'}</S.TableCell>
                    <S.TableCell filled={isFilled}>{hole.courseHoleNumber ?? '—'}</S.TableCell>
                    <S.TableCell style={{ textAlign: 'right' }}>
                      <TrashIconContainer
                        disabled={!isFilled}
                        onClick={(e) => {
                          e.stopPropagation()
                          if (isFilled) {
                            removeRatingHole(index)
                          }
                        }}
                        style={{ width: 28, height: 28 }}
                      >
                        <FeatherIcon name="trash" size={14} color="white" />
                      </TrashIconContainer>
                    </S.TableCell>
                  </S.TableRow>
                )
              })}
            </tbody>
          </S.StyledTable>
        </S.TableContainer>
      )}
    </>
  )
}

export default RatingHoles
